import React, { Component } from 'react'
import { connect } from 'react-redux';
import { sendCredsFromDb, sendCredsToDb, sendCharttoDb, sendProductToDb } from '../apiServices';
import { Paper, Box, Typography, List, ListItem, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core';
import { browserHistory } from 'react-router';
import { withSnackbar } from 'notistack';
import checkApiStatus from '../../../../utils';
import { ListLoader } from '../../../../shared';
import { getLocalStorageInfo } from '../../../../utils_v2';
import { EmptyCollection, PageLoader } from '../../../../shared_elements';
const style = {
    homePage: {
        marginLeft: "60px"
    }
}
class ThirdPartyLanding extends Component {
    constructor(props) {
        super(props)
        this.state = {
            remaining: null,
            pageLoader: false,
            successList: [],
            errorList: [],
            isSuccess: null
        }
        this.sendCredsToDb = sendCredsToDb.bind(this)
        this.sendCredsFromDb = sendCredsFromDb.bind(this)
    }
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location?.search)
        if (urlParams.get('error')) {
            localStorage.removeItem('thirdPartyState');
            localStorage.removeItem('thirdPartyAccountState');
            localStorage.removeItem('thirdPartyProductState');
            if (window.opener && window?.opener.location) { window.opener.location.reload(); }
            window.close();
            return;
        }
        const syncState = localStorage.getItem('thirdPartyState')
        const syncAccState = localStorage.getItem('thirdPartyAccountState')
        const syncProductState = localStorage.getItem('thirdPartyProductState')
        let code = window.location?.search.split('code=')[1].split('&')[0]
        let realmId = window.location?.search.split('realmId=')[1]
        let synState = (syncState && syncState === 'SyncFromQB') ? (Math.floor(Math.random() * 9000) + 1000): window.location?.search.split('state=')[1].split('&')[0]
        if (code == 'error') {
            console.log('');
        }
        else {
            this.setState({ pageLoader: true })
            const apiCall = syncState === 'SyncFromQB' ?sendCredsFromDb : syncAccState === 'SyncAccFromQB'? sendCharttoDb : syncProductState === 'SyncProductService'? sendProductToDb : sendCredsToDb;

            apiCall({ auth_code: code, realm_id: realmId, state: synState })
                .then((response) => {
                    this.setState({ pageLoader: false })
                    const successList = response?.data?.success_message ? response?.data?.success_message.trim().split('\n') : [];
                    const errorList = response?.data?.error_message ? response.data.error_message.trim().split('\n') : [];
                    const isSuccess = !successList.length && !errorList.length
                    if (checkApiStatus(response)) {
                        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        this.setState({ successList, errorList ,isSuccess});
                        localStorage.removeItem('thirdPartyState');
                        localStorage.removeItem('thirdPartyAccountState');
                        localStorage.removeItem('thirdPartyProductState');
                    }
                    if (!successList.length && !errorList.length) {
                        let i = this.state.isSuccess ? 30 : 30;
                        this.setState({ remaining: i });

                        const interval = setInterval(() => {
                            i--;
                            this.setState({ remaining: i });
                            if (i <= 0) clearInterval(interval);
                        }, 1000);

                        setTimeout(() => {
                            window.open('', '_self', '');
                            window.close();
                        }, this.state.isSuccess ? 30000 : 30000);
                        
                        if (window.opener && window?.opener.location) {
                            window.opener.location.reload();
                        }
                    }
                })
        }
    }
    render() {
        let code = window.location?.search?.split('code=')[1]?.split('&')[0];
        return (
            <div style={style.homePage}>
                {this.state?.pageLoader ? <PageLoader/> : null}
                <Paper>
                    <div style={{ height: '92vh', textAlign: 'center' }}>
                        {
                            code == 'error' ?
                                <div style={{ fontSize: '40px' }} > Oops, Something went wrong from QuickBooks side.</div>
                                :
                                <div style={{ fontSize: '40px' }} >
                                    Authentication successful with QuickBooks
                                </div>
                        }
                        {this.state.pageLoader?<div style={{ fontSize: '20px' }} > Do not refresh the page.</div>:null}
                        <div>
                            {
                                code == 'error' ?
                                    <span>Please contact with Sparta team. </span> : null
                            }
                            {
                                this.state?.remaining === null ? null :
                                    `This tab will close in ${this.state.remaining} seconds.`
                            }
                        </div>
                        {(this.state?.successList?.length || this.state?.errorList?.length) ? (
                            <div style={{ display: 'flex', width: '100%', marginTop: '30px', gap: '10px', padding: '0px 10px' }}>
                                <div style={{ flex: 1 }}>
                                    <Paper style={{ background: '#e6ebfb' }}><h3 style={{ color: 'green' }}>Success</h3></Paper>
                                    <TableContainer component={Paper} style={{ height: (window.innerHeight - 300) + 'px' }}>
                                        <Table className='mui-table-format' stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Sl No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Message</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.successList?.map((msg, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell style={{ width: "60px", fontWeight: "bold" }}>{idx + 1} </TableCell>
                                                        <TableCell>
                                                            <span style={{ color: "#1a73e8", fontWeight: 600 }}> {msg.split(":")[0]} </span> :{msg.split(":")[1]}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Paper style={{ background: '#e6ebfb' }}><h3 style={{ color: 'red' }}>Error</h3></Paper>
                                    <TableContainer component={Paper} style={{ height: (window.innerHeight - 300) + 'px' }}>
                                        <Table className='mui-table-format' stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Sl No.</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Message</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.errorList?.map((msg, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell style={{ width: "60px", fontWeight: "bold" }}>{idx + 1} </TableCell>
                                                        <TableCell>
                                                            <span style={{ color: "#1a73e8", fontWeight: 600 }}> {msg.split(":")[0]} </span> :{msg.split(":")[1]}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        {!this.state.errorList.length ? <EmptyCollection description={'No Error Found'} /> : null}
                                    </TableContainer>
                                </div>

                            </div>
                        ) : null}
                        <div style={{ marginTop: "20px", textAlign: "center" }}>
                            <Button variant="outlined" color="primary" size='small' disabled={this.state.pageLoader} onClick={() => { if (window.opener && window?.opener.location) { window.opener.location.reload(); } window.close(); }} >
                                Close Window
                            </Button>

                        </div>
                    </div>
                </Paper>
            </div>
        )
    }
}

export default withSnackbar(ThirdPartyLanding);